import { getDriverCategoriesRequest } from "../data/driverCategoryApi";

export async function getDriverCategoriesUseCase() {
  const response = await getDriverCategoriesRequest();
  if (response.data?.message !== "ok" || !Array.isArray(response.data.data)) {
    throw new Error("No se pudieron cargar las categorías de licencia");
  }
  return response.data.data;
}
